module.exports = __webpack_public_path__ + "static/media/SuccessIcon.51270e83.svg";